import React from "react";
import { Search as SearchIcon } from "react-feather";
import classes from "./searchTrigger.module.css";
import { useSearchTrigger } from "../../Pregrine/SearchTrigger/useSearchTrigger";

const SearchTrigger = React.forwardRef((props, ref) => {
  const { active, onClick } = props;

  const talonProps = useSearchTrigger({
    onClick,
  });
  const { handleClick } = talonProps;

  const searchClass = active ? classes.open : classes.root;

  const searchText = "Search";

  return (
    <button
      className={searchClass}
      aria-label={searchText}
      onClick={handleClick}
      ref={ref}
    >
      <SearchIcon size={24} />
      {/* <span className={classes.label}>{searchText}</span> */}
    </button>
  );
});

export default SearchTrigger;
